<template>
    <div class="ciam-titlebar">
        {{ text }}
    </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style>
    .ciam-titlebar {
        width: 100%;
        height: 45px;
        padding: 15px;
        position: relative;

        font-size: 1rem;
        line-height: 16px;
        color: #fff;

        background-color: #000;
    }
</style>
